import { FolderItem } from '../../types'

type Props = {
  setFolderStack: (stack: FolderItem[]) => void
  folderStack: FolderItem[]
}

const FilePathBreadcrum = ({ folderStack, setFolderStack }: Props) => {
  const ROOT_ITEM: FolderItem = { id: 'root', name: 'Files', createdAt: '' }
  const displayStack = [ROOT_ITEM, ...folderStack]

  const onPathClick = (idx: number) => () => {
    if (idx === 0) {
      // Clicked on "Files" - go to root
      setFolderStack([])
    } else {
      // Clicked on a folder - navigate to that level
      setFolderStack(folderStack.slice(0, idx))
    }
  }

  return (
    <nav aria-label="Breadcrumb">
      <div className="overflow-x-auto scrollbar-hide">
        <ol className="inline-flex items-center space-x-1 md:space-x-3 min-w-max ">
          {displayStack.map((path, i) => (
            <li
              key={path.id || i}
              className="inline-flex items-center flex-shrink-0"
            >
              <button
                className={`inline-flex items-center px-1 py-2.5 md:py-2 text-sm md:text-base font-medium rounded-md transition-all duration-75 hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-inset min-h-[44px] ${
                  i === displayStack.length - 1
                    ? 'text-gray-700 bg-gray-50 cursor-default'
                    : 'text-green-600 hover:text-green-800 hover:bg-green-100'
                }`}
                onClick={
                  i === displayStack.length - 1 ? undefined : onPathClick(i)
                }
                disabled={i === displayStack.length - 1}
                type="button"
              >
                {i === 0 && (
                  <svg
                    className="w-4 h-4 md:w-5 md:h-5 mr-1.5 md:mr-2 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                  </svg>
                )}
                <span className="truncate max-w-24 md:max-w-32 whitespace-nowrap">
                  {path.name}
                </span>
              </button>
              {i < displayStack.length - 1 && (
                <svg
                  className="w-4 h-4 md:w-5 md:h-5 text-gray-400 mx-0.5 md:mx-1 flex-shrink-0"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  )
}

export default FilePathBreadcrum
